import PropTypes from 'prop-types';

export const FormMeta = PropTypes.shape({
  touched: PropTypes.bool.isRequired,
  error: PropTypes.string,
  warning: PropTypes.string,
});

export const SelectOptions = PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })
);
